import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

import { List, MessageCircleMore, MessageSquareReply, TriangleAlert } from 'lucide-vue-next';



export default /*#__PURE__*/_defineComponent({
  __name: 'WorkflowTaskIcon',
  props: {
  workflowTaskType: String,
  workflowTaskSubtype: {
    type: String,
    required: false,
    default: undefined
  }
},
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (props.workflowTaskType === 'text')
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(_unref(MessageCircleMore), {
          color: "#3EA761",
          "stroke-width": 1.5
        })
      ]))
    : (props.workflowTaskType === 'interactive' && props.workflowTaskSubtype === 'LIST')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_unref(List), {
            color: "#3EA761",
            "stroke-width": 1.5
          })
        ]))
      : (props.workflowTaskType === 'interactive' && props.workflowTaskSubtype === 'BUTTON')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createVNode(_unref(MessageSquareReply), {
              color: "#3EA761",
              "stroke-width": 1.5
            })
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _createVNode(_unref(TriangleAlert), {
              color: "#EDA900",
              "stroke-width": 1.5
            })
          ]))
}
}

})